var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useConfigContext } from '../config-provider';
import cx from 'classnames';
import React from 'react';
var Basic = function (props) {
    var className = props.className, _a = props.size, size = _a === void 0 ? 'small' : _a;
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-spin";
    var prefixClsBasic = prefixCls + "-basic";
    var prefixClsSize = prefixClsBasic + "-" + size;
    return React.createElement("div", __assign({}, props, { className: cx(className, prefixCls, prefixClsBasic, prefixClsSize) }));
};
export default Basic;
//# sourceMappingURL=basic.js.map